import React from "react";
import style from "./index.module.scss";
import Header from "components/Header";
import NavBar from "../components/NavBar";
import { useAtomValue } from "jotai";
import { unReadCountAtom } from "../store";

interface NoticeLayoutProps {
    children: React.ReactNode;
}

export default function NoticeLayout({ children }: NoticeLayoutProps) {
    const counts = useAtomValue(unReadCountAtom);

    return (
        <div>
            <Header counts={counts} />

            <div className={style.root}>
                <div className={style.head}>通知</div>

                <NavBar />

                <div className={style.main}>{children}</div>
            </div>
        </div>
    );
}
